import type { TacticGroup } from './types';

export const FETCH_TACTICS = 'FETCH_TACTICS' as const;
export const RESOLVE_TACTICS = 'RESOLVE_TACTICS' as const;
export const REJECT_TACTICS = 'REJECT_TACTICS' as const;

/** Request the campaign/tactic listing (N+1 fetch happens in the saga). */
export const fetchTactics = () => ({ type: FETCH_TACTICS });

/** Store the grouped campaign/tactic listing. */
export const resolve = (groups: TacticGroup[]) => ({
  type: RESOLVE_TACTICS,
  payload: groups,
});

export const reject = (error: Error) => ({
  type: REJECT_TACTICS,
  payload: error,
});

export type FetchAction = ReturnType<typeof fetchTactics>;
export type ResolveAction = ReturnType<typeof resolve>;
export type RejectAction = ReturnType<typeof reject>;
export type TacticsAction = FetchAction | ResolveAction | RejectAction;
